exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".result-component{width:90%;margin-left:5%;min-height:100vh;background:#fff}.result-component .success{padding-top:50px;width:100%;text-align:center;font-weight:400;font-size:16px;color:#41464b}.result-component .erweima{width:200px;height:200px;margin:30px auto}.result-component .img{width:200px;height:200px;border:.5px solid #e6e6e6}.result-component .more-info{width:100%;font-size:12px;color:#666;margin-top:20px;text-align:center}.result-component .wechat{font-size:10px;margin-top:10px;color:#999}.result-component .bottom-button{margin-top:50px;height:38px;line-height:38px;font-weight:400;text-align:center;background-color:#41464b;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Result.scss
// module id = 668
// module chunks = 0